<template>
  <v-container>
    <v-row justify="center">
      <v-col
        md="6"
        sm="12"
        class="text-center my-5">
        <h2
          class="accent--text text-center my-3 display-3">
          Goal Guide
        </h2>
        <p class="body-1">No need to go the entrepreneurial journey alone</p>
        <p class="body-1 mt-10">Enhance your EntreGoal Summit experience with
        supplemental worksheets, resources, checklists
        and guides provided by the speakers</p>
        <v-btn class="mt-5" color="success" disabled>
          Grab Yours
        </v-btn>
        <p class="overline mt-1">Coming soon</p>
      </v-col>
      <v-col
        md="6"
        sm="12"
      >
        <v-img
          src="../assets/GoalGuide600.png"
          max-height="400"
          contain
        >
        </v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

  name: 'LandingGoalGuide',
};
</script>

<style lang="css" scoped>
</style>
